export const GC_USER_ID = 'graphcool-user-id';
export const GC_USER_TYPE = 'graphcool-user-type';
export const AUTH_TOKEN = 'auth-token';
export const LANG = 'lang';
export const DRAFT_EMPLOYEE = 'draft-employee';
export const DRAFT_TRAINING = 'draft-training';
